import { Button, Result } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { RNCarrierSelect } from '../helpers/routeNames'

export const Page404: FC = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()

	return (
		<>
			<Result
				style={{
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center'
				}}
				status="404"
				title="404"
				subTitle={t('PageNotFound')}
				extra={
					<>
						<Button
							type="primary"
							onClick={() => navigate(-1)}>
							{t('GoBack')}
						</Button>
						<Button
							type="primary"
							onClick={() => navigate(RNCarrierSelect)}>
							{t('GoHome')}
						</Button>
					</>
				}
			/>
			<style>{`.ant-result-image {margin-top: 24px!important}`}</style>
		</>
	)
}
